// Tramonto medio a Napoli (40.85°N) per metà mese, ora locale (CET/CEST), in ore decimali.
const NAPLES_SUNSET = [
  17.1, // gen
  17.7, // feb
  18.2, // mar
  19.8, // apr (CEST)
  20.3, // mag
  20.7, // giu
  20.6, // lug
  20.0, // ago
  19.2, // set
  18.3, // ott
  16.8, // nov
  16.6, // dic
];

const DAWN_HOUR = 7; // tra mezzanotte e l'alba resta modalità sera

export function naplesSunsetHour(date = new Date()) {
  const month = date.getMonth();
  const day = date.getDate();
  return NAPLES_SUNSET[month] + (day > 15 ? 0.1 : 0);
}

export function isEveningNow(date = new Date()) {
  const hour = date.getHours() + date.getMinutes() / 60;
  return hour >= naplesSunsetHour(date) || hour < DAWN_HOUR;
}
